<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="login2background" style="background-image: url(assets/img/global/fundo_login.jpg)">
  <div class="main-content container-fluid">
    <div class="splash-container">
      <div class="card">
        <div class="card-header" style="background: none; border-bottom: 0px">
          <img src="assets/img/e-sic.png" width="55" height="55" class="ml-4 float-left">
          <span class="pl-1 font-weight-bold float-left text-black-50">e-SIC</span><br>
          <span class="pl-1 font-weight-bold float-left text-black-50">SERVIÇO DE INFORMAÇÃO AO CIDADÃO</span>
        </div>
        <div class="card-body">
          <form id="login-form">
            <div *ngIf="msgs" class="alert alert-danger" role="alert">
              {{msgs}}
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <input type="text" class="form-control" name="email" [(ngModel)]="email"
                  placeholder="Informe o seu e-mail de acesso">
              </div>
            </div>
            <div class="row">
              <div class="col-7">
                <div class="form-group">
                  <button type="button" (click)="voltar()" class="btn btn-link">Voltar</button>
                </div>
              </div>
              <div class="col-5">
                <div class="form-group">
                  <button type="button" (click)="enviarEmail()" class="btn btn-block btn-primary">Recuperar acesso</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
